export const informationScienceCourseData = [
	{
		imageUrl: require("../assets/courses/card/mcom.png"),
		title: "Master of Commerce ",
		//link: "/bachelor-of-science-honours",
		name: "M.Com"
	},

	{
		imageUrl: require("../assets/courses/card/mcomfc.png"),
		title: " Master of Commerce (F&C)",
		//link: "/bachelor-of-business-administration",
		name: "M.Com(FC)"
	},
	{
		imageUrl: require("../assets/courses/card/mpmir.png"),
		title: "Master in Personal Management & Industrial Relations",
		//link: "/bachelor-of-science",
		name: "MPMIR"
	},
	{
		imageUrl: require("../assets/courses/card/msc.png"),
		title: "Master of Science CS",
		//link: "/bachelor-of-computer-application",
		name: "M.Sc(CS)"
	},
    {
		imageUrl: require("../assets/courses/card/mscphy.png"),
		title: "Master of Science Physics",
		//link: "/bachelor-of-computer-application",
		name: "M.Sc(Phy)"
	},
    {
		imageUrl: require("../assets/courses/card/mscchem.png"),
		title: "Master of Science Chemistry",
		//link: "/bachelor-of-computer-application",
		name: "M.Sc(Chem)"
	},
	{
		imageUrl: require("../assets/courses/card/msw.png"),
		title: "Master in Social Work ",
		//link: "/bachelor-in-bio-technology",
		name: "MSW"
	},
    
	{
		imageUrl: require("../assets/courses/card/bba.png"),
		title: "Bachelor of Business Administration",
		//link: "/master-in-personal-management-and-industrial-relations",
		name:"BBA"
	},
	{
		imageUrl: require("../assets/courses/card/bca.png"),
		title: "Bachelor of Computer Application ",
		//link: "/master-in-computer-science",
		name:"BCA"
	},
	{
		imageUrl: require("../assets/courses/card/bsccs.png"),
		title: "Bachelor of Science CS",
		//link: "/master-in-physics",
		name:"B.Sc(CS)"
	},
	{
		imageUrl: require("../assets/courses/card/bschons.png"),
		title: "Bachelor of Science Hons",
		//link: "/master-in-chemistry",
		name:"B.Sc(Hons)"
	},
	{
		imageUrl: require("../assets/courses/card/bcom.png"),
		title: "Bachelor of Commerce",
		//link: "/master-in-biotech",
		name:"B.Com"
	},
	{
		imageUrl: require("../assets/courses/card/ba.png"),
		title: "Bachelor of Arts",
		//link: "/master-in-social-work",
		name:"B.A"
	},
	{
		imageUrl: require("../assets/courses/card/bscitm.png"),
		title: "Bachelor of Science ITM ",
		//link: "/master-in-social-work",
		name:"B.Sc ITM"
	},
	{
		imageUrl: require("../assets/courses/card/bscbio.png"),
		title: "Bachelor of Science Bio-technology",
		//link: "/master-in-social-work",
		name:"B.Sc Bio-tech"
	},

];


